import './OrdineCompletato.css';
import API from '../../library/ApiManager'
import Fnc from '../../library/Functions';
import React, { useState, useEffect } from 'react';

function OrdineCompletato(props) {

	useEffect(() => {
		// Similar to componentDidMount and componentDidUpdate:

		getOrderData(props.payResult);

	}, [props.payResult, props.basketProds]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

	const [orderError, setOrderError] = useState(false);
	const [errCode, setErrCode] = useState(null);
	const [prevProds, setPrevProds] = useState(null);
	const [payProds, setPayProds] = useState(null);

	function getOrderData(payResult) {

		//----------- GA CHECKOUT
		let bskAndProds = JSON.parse(sessionStorage.getItem(Fnc.prodListName));

		if (bskAndProds && bskAndProds !== null && bskAndProds.prodFiltered && bskAndProds.prodFiltered.length > 0) {
		  let currStep = Fnc.getStepByUrl();
		  let checkStep = currStep.gaCheckoutStep;
		  Fnc.gaCheckout(checkStep,bskAndProds);
		}
		//-----------------------

		if (payResult != null && (payResult.code === Fnc.EnmPay.OK || payResult.code === Fnc.EnmPay.OKDIRECT || payResult.code === Fnc.EnmPay.OKDIRECTPREV)) {

			if (bskAndProds && bskAndProds !== null && bskAndProds.prodFiltered && bskAndProds.prodFiltered.length > 0) {

				let basketProds = bskAndProds.prodFiltered;

				//PRODOTTI PREVENTIVO
				let prvPrds = basketProds.filter(p => {
					return p.type.code === Fnc.EnmProdType.PREV.code;
				});
				setPrevProds(prvPrds);

				//PRODOTTI PAY
				let payPrds = basketProds.filter(p => {
					return p.type.code === Fnc.EnmProdType.PAY.code;
				});
				setPayProds(payPrds);

				let objPay = null;
				if (payResult.code === Fnc.EnmPay.OK) {
					//ZUORA IFRAME
					objPay = JSON.parse(payResult.obj);
				} else {
					//DIRECT
					objPay = payResult.obj
				}

				

				if (payResult.code !== Fnc.EnmPay.OKDIRECTPREV) {
					//solo in caso di acquisto "vero"ho un ordine, i preventivi sono solo leed e non vengono registrati su db come ordini

					if (objPay.id != null && objPay.id.length > 0) {
						//ho un id ordine da usare per fare un check

						API.getOrder(objPay.id, (data) => {
							if (data && data.response && data.response.code === 'OK') {

								/*
								//======= SI E' DECISO DI NON CONTROLLARE PIU LO STATO DELL'ORDINE ===
								if (data.orderData && data.orderData.status === 'CREATED') {
									//OK stampo i dati di riepilogo
		
								} else {
									//KO  errore SF003
									setOrderError(true);		
		
								}*/

								Fnc.gaPurchase(objPay.id, bskAndProds);
								setOrderError(false);

							} else {
								setOrderError(true);
								setErrCode("GTORKO");
								Fnc.gaException("[OrdineCompletato.js@getOrderData] Ordine non trovato lato server", JSON.stringify(payResult), true, Fnc.ExcCatgory.ORDER_CONFIRM.val);
							}

						});


					} else {
						setOrderError(true);
						setErrCode("NOORID");
						Fnc.gaException("[OrdineCompletato.js@getOrderData] Id transazione ordine vuoto", JSON.stringify(payResult), true, Fnc.ExcCatgory.ORDER_CONFIRM.val);
					}

				} else {
					//in questo else sono compresi anche i pagamenti con Paypal che sono diretti, quindi non sono sempre e solo prventivi
					let transactionId = objPay.id != null && objPay.id.length > 0 ? objPay.id : ("PREV_" + Math.floor(Math.random() * 10));
					Fnc.gaPurchase(transactionId, bskAndProds);
				}

			} else {
				setOrderError(true);
				setErrCode("NOPRODS");
				Fnc.gaException("[OrdineCompletato.js@getOrderData] Nessun prodotto trovato in sessione", JSON.stringify(payResult), true, Fnc.ExcCatgory.ORDER_CONFIRM.val);
			}

		} else {
			setErrCode("CKKO");
			setOrderError(true);
			Fnc.gaException("[OrdineCompletato.js@getOrderData] Oggetto ordine vuoto o non valido", JSON.stringify(payResult), true, Fnc.ExcCatgory.ORDER_CONFIRM.val);
		}

	}

	function gotoAreaClienti() {
		let areaClientiPath = Fnc.currEnv().areaClientiPath;
		window.location.href = areaClientiPath;
	}

	return (
		<>
			<div className="iol-checkout-left-part col-xl-7">
				{!orderError &&
					<>
						{payProds && payProds !== null && payProds.length > 0 &&
							<div className="iol-acquired-services"><p className="iol-final-summary-title semibold">Ora attiva il tuo servizio</p>
								<p className="iol-final-summary-subtitle">Ti abbiamo inviato un’email di conferma.
Aprila e confermala per accedere all’Area Clienti e configurare il tuo prodotto.<br/><br/>
Una volta completata la configurazione, inizierai a ricevere i tuoi preventivi</p>

								<div className="iol-services-wrapper">
									<ul className="iol-services-list">
										{payProds.map((prod, index) => (
											<li className="iol-service semibold" key={prod.id}>{prod.description}</li>
										))}
										<button onClick={gotoAreaClienti} key="btnAreaClienti" className="fucsia-button iol-access-button">Accedi all'area clienti</button>
									</ul>
								</div>

							</div>
						}
						{prevProds && prevProds !== null && prevProds.length > 0 &&
							<div className="iol-quotation-request"><p className="iol-final-summary-title semibold">Richieste di preventivo</p>
								<p className="iol-final-summary-subtitle">Un nostro agente ti ricontatterà per i seguenti preventivi:</p>
								<div className="iol-quotation-wrapper">
									<ul className="iol-quotation-list">
										{prevProds.map((prod, index) => (
											<li className="iol-service semibold" key={prod.id}>{prod.description}</li>
										))}
									</ul>
								</div>
							</div>
						}
					</>
				}
				{orderError &&
					<p className="iol-final-summary-title semibold">[{errCode}] Sembra che ci sia stato un errore durante la procedura di pagamento. Per ogni ulteriore informazione contatta il servizio clienti al numero <a href="tel:800011411" rel="noopener"><strong>800 011 411</strong></a></p>
				}
			</div>
			<div className="iol-checkout-right-part col-xl-4 offset-xl-1"></div>
		</>
	);
}

export default OrdineCompletato;
